<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="periods" :hide-actions="true" item-key="code" no-data-text="Список периодов пуст">
          <template #items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.start | date }}</td>
            <td>{{ props.item.finish | date }}</td>
            <td class="text-xs-right">
              <v-btn flat icon title="Редактировать" color="primary">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon title="Удалить" color="error">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout mt-3>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="newPeriod.dialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="info" v-on="on">Добавить</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новый период</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="newPeriod.valid" ref="newPeriodForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-menu :close-on-click="true" :close-on-content-click="false" lazy full-width :nudge-right="40" min-width="290px">
                        <template #activator="{ on }">
                          <v-text-field label="Дата начала периода" required readonly v-model="newPeriod.values.start_date" v-on="on" prepend-icon="event"></v-text-field>
                        </template>
                        <v-date-picker v-model="newPeriod.values.start_date" no-title scrollable locale="ru"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-menu :close-on-click="true" :close-on-content-click="false" lazy full-width :nudge-right="40" min-width="290px">
                        <template #activator="{ on }">
                          <v-text-field label="Дата окончания периода" required readonly v-model="newPeriod.values.finish_date" v-on="on" prepend-icon="event"></v-text-field>
                        </template>
                        <v-date-picker v-model="newPeriod.values.finish_date" no-title scrollable locale="ru"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="dlgNewPeriodClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="dlgNewPeriodSave" :loading="newPeriod.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  filters: {
    date (str) {
      const d = new Date(str)
      const year = d.getFullYear()
      const month = `${d.getMonth() + 1}`.padStart(2, '0')
      const day = `${d.getDate()}`.padStart(2, '0')
      return `${day}/${month}/${year}`
    }
  },
  data: () => ({
    newPeriod: {
      dialog: false,
      valid: false,
      saving: false,
      values: {
        id: '',
        start_date: null,
        finish_date: null
      },
      rules: {
        start_date: [
          v => !!v || 'Обязательно нужно указать начало'
        ],
        finish_date: [
          v => !!v || 'Обязательно нужно указать окончание'
        ]
      }
    },
    headers: [
      {
        text: 'ID периода',
        align: 'left',
        sortable: false,
        value: 'id'
      },
      {
        text: 'Дата начала',
        align: 'left',
        sortable: true,
        value: 'start'
      },
      {
        text: 'Дата окончания',
        align: 'left',
        sortable: true,
        value: 'finish'
      },
      {
        text: '',
        value: null
      }
    ]
  }),
  computed: {
    periods () {
      return Object.values(this.$store.getters['periods/periods'])
    }
  },
  mounted() {
    this.loadPeriods()
  },
  methods: {
    loadPeriods () {
      this.$store.dispatch('periods/getPeriods').catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },

    dlgNewPeriodClose () {
      this.newPeriod.dialog = false
      this.$refs.newPeriodForm.reset()
    },
    dlgNewPeriodSave () {
      if (this.$refs.newPeriodForm.validate()) {
        this.newPeriod.saving = true
        this.$store.dispatch('periods/savePeriod', this.newPeriod.values).then(() => {
          this.$events.$emit('notify', {
            message: 'Период успешно сохранен',
            type: 'info'
          })
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        }).finally(() => {
          this.newPeriod.saving = false
          this.dlgNewPeriodClose()
        })
      }
    }
  }
}
</script>
